import { Field, FormikProps } from 'formik';
import * as React from 'react';

import { TwsAdmin, AmenitiesFormData } from './types';
import MaterialSelectInput from '../input-select';

interface OwnProps {
    choicesLoaded: boolean | null;
    choicesData: TwsAdmin.AmenitiesFormChoices | null;
    valuesLoaded: boolean | null;
    formikProps: FormikProps<AmenitiesFormData>;
}

export default class PoliciesCard extends React.Component<OwnProps> {
    constructor(props: OwnProps) {
        super(props);
    }

    render() {
        const { choicesLoaded, choicesData, valuesLoaded } = this.props;

        const dataFullyLoaded = choicesLoaded && !!choicesData && valuesLoaded;

        return (
            <div className='VenueManagement--card VenueManagement--policies'>
                <div className='VenueManagement--card--header'>Policies</div>
                <div className='VenueManagement--card--subheader'>Specify options and policies for this venue</div>
                {((choicesLoaded && !choicesData) || valuesLoaded === false) && (
                    <div className='VenueManagement--card--body VenueManagement--form-level-error'>
                        Could not load form data, please try again later
                    </div>
                )}

                {dataFullyLoaded && (
                    <div className='VenueManagement--card--body'>
                        <div className='VenueManagement--row'>
                            <div className='VenueManagement--col'>
                                <Field
                                    label='Kitchen facilities'
                                    component={MaterialSelectInput}
                                    name='kitchen_facilities'
                                    readonly={true}
                                    choices={!!choicesData ? this.choicesToArray(choicesData.kitchen_facilities) : []}
                                />
                            </div>
                            <div className='VenueManagement--col-divider' />
                            <div className='VenueManagement--col'>
                                <Field
                                    label='Catering options'
                                    component={MaterialSelectInput}
                                    readonly={true}
                                    name='catering_option'
                                    choices={!!choicesData ? this.choicesToArray(choicesData.catering_option) : []}
                                />
                            </div>
                        </div>
                        <div className='VenueManagement--row'>
                            <div className='VenueManagement--col'>
                                <Field
                                    label='Alcohol policy'
                                    component={MaterialSelectInput}
                                    readonly={true}
                                    name='alcohol_policy'
                                    choices={!!choicesData ? this.choicesToArray(choicesData.alcohol_policy) : []}
                                />
                            </div>
                            <div className='VenueManagement--col-divider' />
                            <div className='VenueManagement--col'>
                                <Field
                                    label='Smoking policy'
                                    component={MaterialSelectInput}
                                    name='smoking_policy'
                                    readonly={true}
                                    choices={!!choicesData ? this.choicesToArray(choicesData.smoking_policy) : []}
                                />
                            </div>
                        </div>
                        <div className='VenueManagement--row'>
                            <div className='VenueManagement--col'>
                                <Field
                                    label='Music policy'
                                    component={MaterialSelectInput}
                                    name='music_policy'
                                    readonly={true}
                                    choices={!!choicesData ? this.choicesToArray(choicesData.music_policy) : []}
                                />
                            </div>
                            <div className='VenueManagement--col-divider' />
                            <div className='VenueManagement--col'>
                                <Field
                                    label='Music end time'
                                    component={MaterialSelectInput}
                                    name='music_end_time'
                                    readonly={true}
                                    choices={!!choicesData ? this.choicesToArray(choicesData.music_end_time) : []}
                                />
                            </div>
                        </div>
                        <div className='VenueManagement--row'>
                            <div className='VenueManagement--col'>
                                <Field
                                    label='Parking options'
                                    component={MaterialSelectInput}
                                    name='parking_option'
                                    readonly={true}
                                    choices={!!choicesData ? this.choicesToArray(choicesData.parking_option) : []}
                                />
                            </div>
                            <div className='VenueManagement--col-divider' />
                            <div className='VenueManagement--col' />
                        </div>
                    </div>
                )}
            </div>
        );
    }

    private choicesToArray<T>(data: TwsAdmin.BaseChoicesData<T>) {
        return data.choices.map((choice) => {
            return [choice.value, choice.label];
        });
    }
}
